<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
  <!-- This is the tree node template for leaf nodes -->
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding tabindex="0">

    <div class="node flex-row gap-8">
      <mat-icon matTooltip="Child step">subdirectory_arrow_right</mat-icon>
      <div>
        <div>
          <strong>{{node.name}}</strong> <br>
          {{node.title}}
        </div>

        @if (node.name === strategyName.Counter) {
        <div class="stars">
          @for (i of Array.from(Array(node.maxStampCount).keys()); track i) {
            <div class="star"
              [class.on]="i < node.stampCount">
            </div>
          }
          <div class="stamps-count">{{ node.stampCount }}/{{ node.maxStampCount }} stamps</div>
        </div>
        }
      </div>
    </div>
    <app-step-actions [strategy]="node" [parent]="parent" [canAdd]="canAdd(node)" [canEdit]="true"
      [canDelete]="true" />
  </mat-tree-node>
  <!-- This is the tree node template for expandable nodes -->
  <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding isExpandable [isExpanded]="true" tabindex="0">
    <div class="node flex-row gap-8">
      @if (node.level === 0) {
        <mat-icon matTooltip="Filter step">receipt_long</mat-icon>
      } @else {
        <mat-icon matTooltip="Child step">subdirectory_arrow_right</mat-icon>
      }
      <div>
        <strong>{{node.name}}</strong> <br>
        {{node.title}}
      </div>
      <app-step-actions [strategy]="node" [parent]="parent" [canAdd]="canAdd(node)" [canEdit]="true"
        [canDelete]="true">
      </app-step-actions>
    </div>
  </mat-tree-node>
</mat-tree>